import { Client } from "fauna";

export const fnV10Client = (token = null) =>
  new Client({
    secret: token || process.env.REACT_APP_PRE_LOGIN_KEY,
    endpoint: process.env.REACT_APP_FAUNA_URL,
  });